<script setup>
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const isSeatLocked = computed(() => route.name === 'account_seat_locked');

const titleKey = computed(() =>
  isSeatLocked.value
    ? 'APP_GLOBAL.SEAT_LOCKED.TITLE'
    : 'APP_GLOBAL.ACCOUNT_SUSPENDED.TITLE'
);

const messageKey = computed(() =>
  isSeatLocked.value
    ? 'APP_GLOBAL.SEAT_LOCKED.MESSAGE'
    : 'APP_GLOBAL.ACCOUNT_SUSPENDED.MESSAGE'
);

const toggleSupportWidgetVisibility = () => {
  if (window.$chatwoot) {
    window.$chatwoot.toggleBubbleVisibility('show');
  }
};

const toggleSupportWidget = () => {
  if (window.$chatwoot) {
    window.$chatwoot.toggle();
  }
};

const setupListenerForWidgetEvent = () => {
  window.addEventListener('chatwoot:on-message', () => {
    toggleSupportWidgetVisibility();
  });
};

onMounted(() => {
  toggleSupportWidgetVisibility();
  setupListenerForWidgetEvent();
});
</script>

<template>
  <div class="items-center bg-n-slate-2 flex justify-center h-full w-full">
    <EmptyState
      class="max-w-lg"
      :title="$t(titleKey)"
      :message="$t(messageKey)"
    >
      <div class="flex flex-col items-center gap-3 mt-4">
        <NextButton
          icon="i-lucide-life-buoy"
          :label="$t('SIDEBAR_ITEMS.CONTACT_SUPPORT')"
          @click="toggleSupportWidget"
        />
      </div>
    </EmptyState>
  </div>
</template>
